<template>
  <div class="trip-axis">
    <svg :width="svgWidth + margin.left + margin.right" :height="height + margin.top + margin.bottom">
      <g ref="svg" :style="{ 'transform': `translate(${margin.left}px, ${margin.top + 24}px)` }"></g>
    </svg>
  </div>
</template>

<script>
import { scaleTime } from 'd3-scale';
import { axisTop } from 'd3-axis';
import { select } from 'd3-selection';
import * as moment from 'moment';

export default {
  name: 'TripAxis',

  props: {
    start: {
      type: Date,
      required: true,
    },
    end: {
      type: Date,
      required: true,
    },
    width: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      svgWidth: 0,
      height: 24,
      margin: { top: 0, bottom: 0, left: 0, right: 0 },
      x: scaleTime(),
      xAxis: axisTop(),
    };
  },

  mounted() {
    this.svgWidth = this.width - this.margin.left - this.margin.right - 144;

    this.x.domain([this.start, this.end]).range([0, this.svgWidth]);

    this.xAxis
      .scale(this.x)
      .ticks(5)
      .tickFormat(d => moment(d).format('h:mm a'));

    select(this.$refs.svg).call(this.xAxis);
  },

  watch: {
    width: function(newWidth) {
      if (newWidth === 0) {
        return;
      }

      this.svgWidth = this.width - this.margin.left - this.margin.right - 144;
      this.x.range([0, this.svgWidth]);

      select(this.$refs.svg).call(this.xAxis);
    },
  },
};
</script>

<style lang="scss">
@import '~scss/utilities/initial-variables.scss';
@import '~scss/utilities/derived-variables.scss';

.trip-axis {
  .domain {
    display: none;
  }

  .tick {
    font-family: $family-sans-serif;

    text {
      fill: rgba($white, 0.87);
      font-size: $size-small;
      font-weight: $weight-medium;
      line-height: 1.5;
      transform: translateY(1px);
    }

    line {
      display: none;
    }
  }
}
</style>

<style lang="scss" scoped>
@import '~scss/utilities/initial-variables.scss';
@import '~scss/utilities/derived-variables.scss';

.trip-axis {
  height: 24px;
  padding-left: 144px;
  background-color: rgba($black, 0.9);
  overflow: hidden;
}
</style>
